import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { TaskServiceInterface } from "./definitions/task-service-interface";
import { Observable } from "rxjs";
import { ErrorsInterface } from "../errors/errors-interface";
import approveTaskMutation from "./mutations/approve";
import { FetchResult } from '@apollo/client/core';

interface ApproveResponse {
  task: {
    approve: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TaskApproveService {
  constructor(private apollo: Apollo) {}

  approve(taskId: string): Observable<FetchResult<ApproveResponse>> {
    return this.apollo.mutate<ApproveResponse>({
      mutation: approveTaskMutation,
      variables: {
        taskId: taskId,
      },
    });
  }
}
